import { authFetch } from 'src/auth/utils';
import { envVariables } from 'src/common/utils/envVariables';

export const enableESimProfile = async ({ eid, iccid }: { eid: string; iccid: string }) => {
  return authFetch(`${envVariables.VITE_ESIMS_INGESTION_API}/enable-profile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ eid: eid, iccid: iccid, isDirectMode: false }),
  });
};

export const addESimProfile = async ({ eid, iccid }: { eid: string; iccid: string }) => {
  return authFetch(`${envVariables.VITE_ESIMS_INGESTION_API}/download-profile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ eid: eid, iccid: iccid, isDirectMode: false }),
  });
};

export const deleteESimProfile = async ({ eid, iccid }: { eid: string; iccid: string }) => {
  return authFetch(`${envVariables.VITE_ESIMS_INGESTION_API}/delete-profile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ eid: eid, iccid: iccid, isDirectMode: false }),
  });
};
